import './Main.css';
import Input from '../../design/Input';
import OtherDetalis from './OtherDetalis';


export default function Main ({data, setData, disable, nameClick, page, setPage}) {

    return (
        <div className="grid">
            <p> שם פרטי באנגלית <span>*חובה</span> </p>
            <p> שם משפחה באנגלית <span>*חובה</span> </p>

            <Input 
            textView="First Name" 
            pattern="strEn" 
            value={data.firstName} 
            onChange= {(e) => {setData({...data, firstName: e})}} 
            language="en" 
            />

            <Input 
            textView="Last Name" 
            pattern="strEn" 
            value = {data.lastName}  
            onChange = {(e) => {setData({...data, lastName: e})}} 
            language="en" 
            />

            <div className="check" onClick={nameClick}>
                <p> יש לבדוק שהשם <span> {data.firstName} {data.lastName} </span> מאוית נכון לאישור לחץ </p>
            </div>

            <div className={! disable ? 'disable addNameOtherDetalis' : ' addNameOtherDetalis'}>
                <OtherDetalis data={data} setData={setData} page={page} setPage={setPage} />
            </div>
        </div>
    )
}